import { render, staticRenderFns } from "./Members.vue?vue&type=template&id=2a89b40b&"
import script from "./Members.vue?vue&type=script&lang=js&"
export * from "./Members.vue?vue&type=script&lang=js&"
import style0 from "./Members.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports